
import Alert from 'vux/src/components/alert/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
data() {
return {
photo: {'path': '', 'serverid': ''},
account: '',
username: '',
sequence: '',
orderDetail: {},
cont: '',
iden: '',
imgList: [],
orders_closed: [],
isHide: true,
solutionv: this.$route.params.solutionv,
url: ''
}
},
components: {
XHeader,
XInput,
Group,
XAddress,
Card,
Alert,
Cell,
XButton
},
methods: {
addrate() {
this.$router.push({
name: 'addrate',
params: {rate: this.orders_closed, solutionv: this.solutionv, url: this.url}
})
},
showSolution() {
this.$http.get('/api/v1/normalrepairs/' + this.orderDetail.seq + '/list_solutions?role=EXPT&offset=0&count=999', {
headers: {
token: localStorage.getItem("token"),
opid: localStorage.getItem("userid")
}
}).then(resposne => {
this.orders_closed = resposne.data.content
}).catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: "cancel",
time: "1000"
});
});
}
},
created() {
var arr
var order = localStorage.getItem('order')
this.orderDetail = JSON.parse(order)
if (this.orderDetail.state === '处理失败,待审核' || this.orderDetail.state === '处理成功,待审核'
|| this.orderDetail.state === 'SUCCESS' || this.orderDetail.state === 'FAIL' || this.orderDetail.state === '成功') {
this.isHide = false
}
if (this.orderDetail.solutionv === 1) {
if (this.orderDetail.solution) {
arr = this.orderDetail.solution.content
this.orders_closed = arr
}
} else {
this.showSolution();
}
this.iden = this.$route.params.iden
},
beforeRouteLeave(to, from, next) {
if (to.name === 'solution_logs') {
to.params.role = this.iden
}
next()
},
beforeRouteEnter(to, from, next) {
if (from.name === 'normalcomplete') {
next(vm => {
vm.url = 'normalcomplete'
vm.isHide = false
})
} else {
if (to.params.isHide) {
next(vm => {
vm.isHide = false
})
} else {
next()
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/makeMemo.vue